// Home.js
import React from 'react';
import ContactMe from './ContactMe';

const Contact = () => {
  return (
    <div>
          <a href="#contact" style={{ textDecoration: 'none' }}><ContactMe /></a>
    </div>
  );
};

export default Contact;
